import { useEffect, useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ProductCard from "../components/ProductCard";
import { api } from "../lib/api";
import { track } from "../lib/analytics";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    track("page_view");
    api.get("/products").then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="App">
      <div className="relative">
        <Header overlay />
        <Hero />
      </div>

      <section
        id="catalog"
        data-testid="catalog-section"
        className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28"
      >
        {loading ? (
          <div data-testid="catalog-loading" className="py-24 text-center text-xs tracking-[0.3em] uppercase" style={{ color: "var(--opus-text-muted)" }}>
            Loading the library…
          </div>
        ) : products.length === 0 ? (
          <div data-testid="catalog-empty" className="py-24 text-center" style={{ color: "var(--opus-text-muted)" }}>
            <p className="font-display text-2xl">Nothing here yet.</p>
            <p className="text-sm mt-2 font-body">New resources are added regularly.</p>
          </div>
        ) : (
          <div
            data-testid="product-grid"
            className="grid grid-cols-1 md:grid-cols-2 gap-7 md:gap-10"
          >
            {products.map((p, idx) => (
              <div key={p.id} className="opus-fade-up h-full" style={{ animationDelay: `${idx * 80}ms` }}>
                <ProductCard product={p} />
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
